import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 40;

const componentsForMigration = [
    'Button',
    'TextInput',
    'DateInput',
    'NumericInput',
    'TextArea',
    'Dropdown',
    'Image',
];

export const migration_39_40:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        let isComponentsVersionMigrated:boolean = false;

        if( designState.visualArtifactsRefs )
        {
            designState.visualArtifactsRefs.forEach(visualArtifactRef =>
            {
                if( visualArtifactRef.organization === 'mintdata'
                    && visualArtifactRef.name === 'mint-components'
                    && visualArtifactRef.version === '0.0.11-SNAPSHOT' )
                {
                    visualArtifactRef.version = '0.0.12-SNAPSHOT';
                    isComponentsVersionMigrated = true;
                }
            });
        }

        if( isComponentsVersionMigrated && designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {component, componentDesc: {_properties}} = boxSnapshot;

                        if( componentsForMigration.indexOf(component.name) !== -1 )
                        {
                            if( _properties )
                            {
                                Object.values(_properties).forEach((property:any) =>
                                {
                                    if( property.name === 'model' && !property._value.boxShadow )
                                    {
                                        property._value.boxShadow = boxShadowModel;
                                    }

                                    if( property.name === 'model' && component.name === 'Dropdown' )
                                    {
                                        property._value = {
                                            ...property._value,
                                            ...dropdownModel
                                        };
                                    }

                                    if( property.name === 'model' && component.name === 'Image' )
                                    {
                                        property._value.hoverState = {
                                            ...property._value.hoverState,
                                            ...imageBorder
                                        };

                                        property._value.activeState = {
                                            ...property._value.activeState,
                                            ...imageBorder
                                        };
                                    }
                                });
                            }
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

const boxShadowModel:any = {
    'color': {
        'color': {
            'hex': {
                '__type': 'STRING',
                'value': '#000000'
            },
            'alpha': {
                '__type': 'NUMBER',
                'value': 0.5
            }
        },
        'visibility': {
            '__type': 'BOOLEAN',
            'value': false
        }
    },
    'deltaX': {
        'value': {
            '__type': 'NUMBER',
            'value': 0
        },
        'unitsType': {
            '__type': 'STRINGENUM',
            'selectedValue': 'px',
            'values': [
                'px',
                '%',
                'auto'
            ]
        }
    },
    'deltaY': {
        'value': {
            '__type': 'NUMBER',
            'value': 2
        },
        'unitsType': {
            '__type': 'STRINGENUM',
            'selectedValue': 'px',
            'values': [
                'px',
                '%',
                'auto'
            ]
        }
    },
    'blur': {
        'value': {
            '__type': 'NUMBER',
            'value': 4
        },
        'unitsType': {
            '__type': 'STRINGENUM',
            'selectedValue': 'px',
            'values': [
                'px',
                '%',
                'auto'
            ]
        }
    },
    'spread': {
        'value': {
            '__type': 'NUMBER',
            'value': 0
        },
        'unitsType': {
            '__type': 'STRINGENUM',
            'selectedValue': 'px',
            'values': [
                'px',
                '%',
                'auto'
            ]
        }
    }
};

const dropdownModel:any = {
    'isMultiple': {
        '__type': 'BOOLEAN',
        'value': false
    },
    'isSearchable': {
        '__type': 'BOOLEAN',
        'value': false
    },
    'isEditable': {
        '__type': 'BOOLEAN',
        'value': false
    },
    'isLoading': {
        '__type': 'BOOLEAN',
        'value': false
    },
    'selectedItems': {
        '__type': 'FRAME',
        'meta': {}
    },
    'border': {
        'borderColor': {
            'color': {
                'hex': {
                    '__type': 'STRING',
                    'value': '#cdced0'
                },
                'alpha': {
                    '__type': 'NUMBER',
                    'value': 1
                }
            },
            'visibility': {
                '__type': 'BOOLEAN',
                'value': true
            }
        },
        'borderThickness': {
            'value': {
                '__type': 'NUMBER',
                'value': 1
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'borderStyle': {
            '__type': 'STRINGENUM',
            'selectedValue': 'solid',
            'values': [
                'solid',
                'dashed',
                'dotted'
            ]
        },
        'borderRadius': {
            'topLeft': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 3
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'topRight': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 3
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'bottomLeft': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 3
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'bottomRight': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 3
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            }
        },
        'borderFill': {
            '__type': 'STRINGENUM',
            'selectedValue': 'borderAll',
            'values': [
                'borderLeft',
                'borderTop',
                'borderRight',
                'borderBottom',
                'borderAll'
            ]
        }
    }
};

const imageBorder:any = {
    'borderColor': {
        'color': {
            'hex': {
                '__type': 'STRING',
                'value': '#000000'
            },
            'alpha': {
                '__type': 'NUMBER',
                'value': 1
            }
        },
        'visibility': {
            '__type': 'BOOLEAN',
            'value': false
        }
    },
    'borderThickness': {
        'value': {
            '__type': 'NUMBER',
            'value': 1
        },
        'unitsType': {
            '__type': 'STRINGENUM',
            'selectedValue': 'px',
            'values': [
                'px',
                '%',
                'auto'
            ]
        }
    },
    'borderStyle': {
        '__type': 'STRINGENUM',
        'selectedValue': 'solid',
        'values': [
            'solid',
            'dashed',
            'dotted'
        ]
    },
    'borderRadius': {
        'topLeft': {
            'value': {
                '__type': 'NUMBER',
                'value': 0
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'topRight': {
            'value': {
                '__type': 'NUMBER',
                'value': 0
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'bottomLeft': {
            'value': {
                '__type': 'NUMBER',
                'value': 0
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'bottomRight': {
            'value': {
                '__type': 'NUMBER',
                'value': 0
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        }
    },
    'borderFill': {
        '__type': 'STRINGENUM',
        'selectedValue': 'borderAll',
        'values': [
            'borderLeft',
            'borderTop',
            'borderRight',
            'borderBottom',
            'borderAll'
        ]
    }
};
